import { create } from 'zustand';

interface ChatWidgetState {
  isOpen: boolean;
  initialQuestion: string | null;
  openChat: (initialQuestion?: string) => void;
  closeChat: () => void;
  clearInitialQuestion: () => void;
}

export const useChatWidgetStore = create<ChatWidgetState>((set) => ({
  isOpen: false,
  initialQuestion: null,
  openChat: (initialQuestion) => set({ isOpen: true, initialQuestion: initialQuestion || null }),
  closeChat: () => set({ isOpen: false, initialQuestion: null }),
  clearInitialQuestion: () => set({ initialQuestion: null }),
}));
